<template>
  <Dialog
    ref="dialog"
    :title="dialogTitle"
    icon="icon-cy-idxDeail"
    :is-show-footer="true"
    width="564px"
    @dialogSure="dialogSure"
  >
    <el-form
      @submit.native.prevent
      :model="paramsForm"
      :rules="paramsFormRules"
      ref="paramsForm"
      label-width="84px"
    >
      <el-form-item
        label="参数类别："
        prop="group"
      >
        <el-input
          v-model.trim="paramsForm.group"
          placeholder="请输入参数类别"
        />
      </el-form-item>
      <el-form-item
        label="参数名称："
        prop="name"
      >
        <el-input
          maxlength="60"
          v-model.trim="paramsForm.name"
          placeholder="请输入参数名称（不超过60个字符）"
        />
      </el-form-item>
      <el-form-item
        label="参数值："
        prop="value"
      >
        <el-input
          v-model.trim="paramsForm.value"
          placeholder="请输入参数值"
        />
      </el-form-item>
      <el-form-item
        label="附加值："
        prop="data"
      >
        <el-input
          v-model.trim="paramsForm.data"
        />
      </el-form-item>
      <el-form-item
        label="参数说明："
        prop="desc"
      >
        <el-input
          type="textarea"
          v-model.trim="paramsForm.desc"
        />
      </el-form-item>
      <!-- <el-form-item
        label="是否启用："
        prop="state"
      >
        <el-radio-group v-model="paramsForm.state">
          <el-radio :label="0">
            是
          </el-radio>
          <el-radio :label="1">
            否
          </el-radio>
        </el-radio-group>
      </el-form-item> -->
    </el-form>
  </Dialog>
</template>

<script>
import Dialog from '@components/dialog/dialog'
export default {
  props: {
    roleList: {
      type: Array,
      default: () => []
    },
    departmentList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Dialog
  },
  computed: {
    isAlter() {
      return this.dialogTitle === '修改系统参数'
    },
    expandedData() {
      if (this.departmentList.length) {
        return [this.departmentList[0].id]
      } else {
        return []
      }
    }
  },
  data() {
    var validateName = (rule, value, callback) => {
      if (value.length === 0) {
        callback(new Error('该处不可为空'))
      } else if (value.length === 60) {
        callback(new Error('仅支持60个字符'))
      } else {
        callback()
      }
    }
    return {
      dialogTitle: '新增系统参数',
      paramsForm: {
        id: 0,
        group: '',
        name: '',
        value: '',
        data: '',
        desc: ' ',
        order: 0
      },
      paramsFormRules: {
        group: [{ required: true, message: '该处不可为空', trigger: 'blur' }],
        name: [{ validator: validateName, required: true, trigger: 'change' }],
        value: [
          { required: true, message: '该处不可为空', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
  },
  methods: {
    initParmas(paramsInfo) {
      if (this.$refs.paramsForm) {
        this.$refs.paramsForm.resetFields()
      }
      this.paramsForm = {
        id: paramsInfo.id || 0,
        group: paramsInfo.group || '',
        name: paramsInfo.name || '',
        value: paramsInfo.value || '',
        data: paramsInfo.data || '',
        desc: paramsInfo.desc || '',
        order: paramsInfo.order || ''
      }
    },
    dialogSure() {
      this.$refs.paramsForm.validate(valid => {
        if (valid) {
          this.$emit('dialogSure', this.paramsForm)
        } else {
          console.log('error')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-dialog.cy-dialog-common {
  .el-dialog__header {
    padding: 28px 30px;
  }
  .el-dialog__body {
    padding: 0 61px 20px 30px;
    .el-form {
      width: 100%;
      &-item {
        margin-bottom: 20px;
        &__label {
          padding: 0;
          line-height: 30px;
        }
        &__content {
          line-height: 30px;
          .el-input__inner {
            height: 30px;
            background: #fff;
            border-radius: 5px;
            color: #454647;
          }
          .el-input-disable {
            .el-input__inner {
              background: #eee;
            }
          }
          .el-textarea__inner {
            background: #fff;
            min-height: 50px !important;
          }
        }
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.el-dialog.cy-dialog-common .el-dialog__body {
  max-height: calc(100vh - 180px) !important;
  overflow-y: auto;
}
</style>
